import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["compact", "responsive"],
  _excluded2 = ["children"];
import { GRID_BREAKPOINT_LARGE } from '../constants';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const InnerSection = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
})(({
  theme,
  compact,
  responsive
}) => Object.assign({
  paddingTop: compact ? theme.space['800'] : theme.space['1100'],
  paddingBottom: theme.space['0'],
  '&:first-child': {
    paddingTop: theme.space['0']
  }
}, responsive && {
  [`@media (max-width: ${GRID_BREAKPOINT_LARGE})`]: {
    paddingTop: theme.space['800']
  }
}));
export const ResponsiveInnerSection = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(InnerSection, Object.assign({}, rest, {
      responsive: true,
      children: children
    }))
  });
};
export default InnerSection;